import { render, staticRenderFns } from "./LookForMedicines.vue?vue&type=template&id=5c677916&"
import script from "./LookForMedicines.vue?vue&type=script&lang=js&"
export * from "./LookForMedicines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports